import { render, staticRenderFns } from "./VerProfesional.vue?vue&type=template&id=a4f37314&scoped=true&"
import script from "./VerProfesional.vue?vue&type=script&lang=js&"
export * from "./VerProfesional.vue?vue&type=script&lang=js&"
import style0 from "./VerProfesional.vue?vue&type=style&index=0&id=a4f37314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f37314",
  null
  
)

export default component.exports